import type KeyCloak from 'keycloak-js';

export async function logout(kc: KeyCloak | null) {
    if ('__TAURI_INTERNALS__' in window) {
        await (
            window as Window & {
                __TAURI_INTERNALS__: {
                    invoke: (cmd: string, args?: Record<string, unknown>) => Promise<unknown>;
                };
            }
        ).__TAURI_INTERNALS__.invoke('plugin:renkiextra|keycloak_delete_tokens');
    }

    if (kc) {
        const redirectUri =
            kc.clientId === 'tauri' ? (import.meta.env.EXPO_PUBLIC_ADDRESSFRONT_URL as string | undefined) : undefined;
        await kc.logout({
            redirectUri,
        });
    }
}
